// extracted by mini-css-extract-plugin
module.exports = {"FormStyleOfPlan":"FormStyleOfPlan_FormStyleOfPlan__2C4_P"};